import { ReactNode } from "react";

import {
    Row,
    Text,
    ToggleSpacedButtons,
    TabsSelect,
    Column,
    Button,
    DialogToggleButton,
    SelectOption,
    ToggleOption
} from "@bridgesplit/ui";
import { Box, Divider } from "@mui/material";
import { Tune } from "@mui/icons-material";
import { DispatchType } from "@bridgesplit/react";

const sharedContainerSx = { width: "100%" };
const sharedButtonSx = {
    flex: 1,
    maxWidth: "none"
};
const sharedTextSx = { fontWeight: "normal" as const };

const actionSettingsButtonSx = { px: 0.5, mx: 0 }; // WindCard.tsx spacing with two buttons next to each other needs to be updated in unison

export function ActionToggleButtons<T extends string | number>({
    value,
    setValue,
    options,
    isNestedDialogView = false
}: {
    value: T;
    setValue: DispatchType<T>;
    options: ToggleOption<T>[];
    isNestedDialogView?: boolean;
}) {
    return !isNestedDialogView ? (
        <ToggleSpacedButtons
            value={value}
            setValue={setValue}
            options={options}
            containerSx={sharedContainerSx}
            buttonSx={sharedButtonSx}
            textSx={sharedTextSx}
            size="small"
        />
    ) : (
        <Column alignItems="flex-start">
            <Box sx={{ position: "relative", width: "100%" }}>
                <TabsSelect
                    value={value}
                    textVariant="body1"
                    setValue={setValue}
                    options={options as SelectOption<T>[]}
                    wrapperSx={{ mx: -2 }}
                    tabSx={{
                        width: "auto",
                        alignItems: "flex-start"
                    }}
                    hideUnselectedDivider={true}
                />
                <Divider
                    sx={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        margin: 0,
                        mx: -2,
                        backgroundColor: "transparent"
                    }}
                />
            </Box>
        </Column>
    );
}

export function DialogSwitchHeader<T extends string | number>({
    options,
    value,
    setValue,
    label
}: {
    options: ToggleOption<T>[];
    value: T;
    setValue: DispatchType<T>;
    label: string;
}) {
    return (
        <Row spaceBetween>
            <Text variant="h4">{label}</Text>
            <DialogToggleButton value={value} setValue={setValue} options={options} />
        </Row>
    );
}

type ActionsSettingsButtonProps = {
    label?: string;
    rowEndText: string;
    onClick: () => void;
    disabled?: boolean;
    loading?: boolean;
    icon?: ReactNode;
};

export function ActionsSettingsButton({
    label,
    rowEndText,
    onClick,
    disabled,
    loading,
    icon = <Tune fontSize="inherit" sx={{ color: "secondary.main" }} />
}: ActionsSettingsButtonProps) {
    const isDisabled = !!disabled || !!loading;

    return (
        <Row spaceBetween>
            {label && (
                <Text variant="body2" color="caption">
                    {label}
                </Text>
            )}
            <Button
                variant="text"
                disabled={isDisabled}
                onClick={onClick}
                width="max-content"
                height={24}
                sx={actionSettingsButtonSx}
                textProps={{
                    variant: "caption",
                    color: "caption"
                }}
            >
                {icon}
                <Text variant="body2" color="caption">
                    {rowEndText}
                </Text>
            </Button>
        </Row>
    );
}

/**
 *
 *
 * MaxButton
 *
 *
 *
 */
